const defaultField = {
    props: {
        helpText: String,
        error: String
    }
}

export default defaultField;
